'use strict';
import util from './util';



var countrySelector = function () {

    $('#selectcountry, #header-selectcountry').on('selectmenuchange change', function(event) {
        event.preventDefault();
        var selectedCountry = $(this).find(':selected');
        var selectedCountryUrl = selectedCountry.val();
        var redirectCheck;
        if(selectedCountry.attr('data-redirect')) {
        	redirectCheck = selectedCountry.attr('data-redirect').trim().toLowerCase();
        }
        if (redirectCheck == 'no') {
        	return false;
        }

        var action = (selectedCountry.attr('data-country').indexOf('other') >= 0) ? '_blank' : '_self';
    
        if(window.open(selectedCountryUrl, action) == null) {
        	document.location.href = selectedCountryUrl;
        }
    });
}

var countryPopinSelector = function () {

    $('.country-selector-form .popin-btn.change').on('click', function() {        
        document.location.href = $('.country-selector-form .countries-selector').val();
    });
    $('#country-selector-popup select').selectmenu({
        classes: {
            'ui-selectmenu-menu': 'countries-select'
        }
    });  
    
}

var countryCookieSet = function () {
    $('#country-selector-popup').find('.close-button, .popin-btn, .modal-close-outer').click(function (e) {
        var element = e.currentTarget;
        var marketID = element.dataset.market;
        var lifetime = element.dataset.countrycookieliftime;
        
        util.setCookie('emea-preferredSite', marketID, lifetime);
        if ($('.language-overlay').length == 0) {
            $('html').removeClass('modal-open');
		    $('body').removeClass('body-fixed');
        } else {
            $('html').addClass('modal-open');
		    $('body').addClass('body-fixed');
        }
    });
    $('#country-selector-popup').find('.popin-btn.close-popup').click(function () {
        $('#country-selector-popup').hide();
    });
}

var languageCookieSet = function () {
    $('#language-selector-popup').find('.close-button, .popin-btn, .modal-close-outer').click(function (e) {
        var element = e.currentTarget;
        var locale = element.dataset.locale;
        var lifetime = element.dataset.countrycookieliftime;
        
        util.setCookie('emea-preferredLocale', locale, lifetime);
        $('html').removeClass('modal-open');
        $('body').removeClass('body-fixed');
    });
}

var isPopinVisible = function () {
    if ($('.js-popin').length > 0) {
        $('.js-popin .modal-body').scrollBox();
        $('html').addClass('modal-open');
        if (navigator.userAgent.match(/(iPhone|iPad)/)) {
        	$('body').addClass('body-fixed');
        }
        $(window).on('load resize orientationchange', function () {
            $('.js-popin .sb-container .sb-content').removeAttr('style');
            $(window).trigger('resize.scrollBox');
        });			
    }
}

var footerSelector = {
    init: function() {
        countrySelector();
        countryCookieSet();
        countryPopinSelector();
        languageCookieSet();
        isPopinVisible();
    }
};

export default footerSelector;
